import uniqid from 'uniqid';
import { gameRoundTime } from './constants';
export enum ContestState{
    open, 
    live,
    close
}

export class Contest{

    gameId      : string
    openTime    : Date
    closeTime   : Date
    liveTime    : number   
    duration    : number
    oddsUp      : number
    oddsDown    : number
    price       : number
    lockedPrice : number
    contestState : ContestState
    poolSize     : number;

    constructor(openTime : Date , state : ContestState , duration : number){

        this.gameId = uniqid();
        this.contestState = state;
        this.openTime = openTime;
        this.closeTime = new Date(openTime.getTime() + gameRoundTime * 1000);
        this.liveTime = 0;
        this.oddsUp = 0;
        this.oddsDown = 0;
        this.price = 0;
        this.lockedPrice = 0;
        this.poolSize = 0;
        this.duration = duration;
    }  
}

export class GameController {
    updateInterval : number = 250;
    interval = 1000;
    btValue = 0;
    baseOdds : number = 1.84;
    constests : Contest[] = [];

    constructor() {

        var socket = new WebSocket('wss://btc.data.hxro.io/live');
        socket.onmessage =  (event) => {
            const message = JSON.parse(event.data);
            this.btValue = message.price;
        };
    }

    getBTCPrice() : number {
        
        return this.btValue;
    }

}

const gameController = new GameController();
export const getBTCPrice = ()=>{

    return new Promise<number>(async(resolve , reject)=>{
        resolve(gameController.getBTCPrice());
    })

}
